

const realTimifyCart = () => {
	const quantityFields = document.querySelectorAll('.pageCart .views-form form .formItem__input--select');

	for (let i = 0; i < quantityFields.length; i++) {
		quantityFields[i].addEventListener('change', () => {
			const form = document.querySelector('.pageCart .views-form form');

			form.submit();
		});
	}
};

const init = () => {
	const isCartPage = document.querySelector('body').classList.contains('pageCart');

	if (isCartPage) {
		realTimifyCart();
	}
};

if (document.loaded) {
   init();
} else if (window.addEventListener) {
   window.addEventListener('load', init, false);
} else {
   window.attachEvent('onload', init);
}
